//--
console.log('window.data.tmpl:', window.data.tmpl);
// var require = {
//@nocollapse
require.config({
	// urlArgs: "cache=v2"
	// ,
	deps : ['boot']
	,
	waitSeconds: 0
	,
	enforceDefine: false
	,
	// urlArgs : (function () { return BB.dev_mode ? 'bust=' + (+new Date) : 'foo=bar'; })()
	// 'urlArgs' : (function () { return 'bust=' + (+new Date); })()
	// ,
  	// urlArgs: "bust=" +  (new Date()).getTime()
	// ,
	// ,
	packages:
	[{
		name: 'moment',
		// This location is relative to baseUrl. Choose bower_components
		// or node_modules, depending on how moment was installed.
		// location: 'node_modules/moment',
		// location: './libr/moment',
		location: './libr/moment/min',
		// main: 'moment'
		main: 'moment-with-locales'
	}]
	,
	'config':
	{
		'GoogleAnalytics':
		{
			'id' : 'UA-643290-1'
		}
		,
		'GoogleMap':
		{
			  // 'zoom': 2
			  // ,
			  // libraries: 'places'
			// 'center': new google.maps.LatLng(0, 0),
			// 'mapTypeId': google.maps.MapTypeId.ROADMAP,
			'urlArgs': "icon=lala",
			'zoom': 2,
			'sensor': false,
			'key': 'AIzaSyAf1LSCOGMO3AnL4auJhtpzawviIisV6wo'
		}
		,
		'Facebook' :
		{
			// //--Dev
			// 'appId'      : '226654457735546'
			//--Prod
			'appId'      : '226651231069202'
			,
			'version'    : 'v2.7'
			,
			'status': true
			,
			'cookie': true
			,
			'xfbml': true
			// ,
			// 'channelUrl': '//' + window.location.hostname + '/facebook-channel.html'
		}
		,
		'Twitter' :
		{

		}
		,
		'TweenMax' :
		{
			'cfasync': "false"
		}
	}
	,
	'paths':
	{
        // "d3src": 							'https://d3js.org',
		"jquery": 							'./libr/jquery/dist/jquery',
		'sortable': 						'./libr/sortablejs/Sortable',
		'tinysort': 						'./libr/tinysort/dist/tinysort',
		"yui_yui": 							'./libr/yui/yui/yui',
		"pace": 							'./libr/pace-js/pace',
		"yui_yql": 							'./libr/yui/yql/yql',
		"domready": 						'./libr/requirejs-domready/domReady',
		"hbs": 				    			'./libr/require-handlebars-plugin/hbs',
		"handlebars": 				    	'./libr/require-handlebars-plugin/hbs/handlebars.runtime',
		"cookies": 							'./libr/js-cookie/src/js.cookie',
		"async": 							'./libr/requirejs-async/async',
		"underscore": 						'./libr/underscore/underscore',

		"hammerjs": 						'./libr/hammerjs/hammer',
		'mag' : 							'./libr/magnificent/src/js/mag',
		'mag-jquery' : 						'./libr/magnificent/src/js/mag-jquery',
		'mag-control' : 					'./libr/magnificent/src/js/mag-control',
		'mag-analytics' : 					'./libr/magnificent/src/js/mag-analytics',
		'google-analytics-js' : 			'./libr/google-analytics-js/gajs',
		'prevent-ghost-click' : 			'./libr/prevent-ghost-click/PreventGhostClick',


		'froala_editor' : 					'./libr/froala/js/froala_editor',
		'froala_languages_es' : 			'./libr/froala/js/languages/es',
		'froala_align' : 					'./libr/froala/js/plugins/align',
		'froala_char_counter' : 			'./libr/froala/js/plugins/char_counter',
		'froala_code_beautifier' : 			'./libr/froala/js/plugins/code_beautifier',
		'froala_code_view' : 				'./libr/froala/js/plugins/code_view',
		'froala_colors' : 					'./libr/froala/js/plugins/colors',
		'froala_draggable' : 				'./libr/froala/js/plugins/draggable',
		'froala_emoticons' : 				'./libr/froala/js/plugins/emoticons',
		'froala_entities' : 				'./libr/froala/js/plugins/entities',
		'froala_file' : 					'./libr/froala/js/plugins/file',
		'froala_font_family' : 				'./libr/froala/js/plugins/font_family',
		'froala_font_size' : 				'./libr/froala/js/plugins/font_size',
		'froala_forms' : 					'./libr/froala/js/plugins/forms',
		'froala_fullscreen' : 				'./libr/froala/js/plugins/fullscreen',
		'froala_image_manager' : 			'./libr/froala/js/plugins/image_manager',
		'froala_image' : 					'./libr/froala/js/plugins/image',
		'froala_inline_style' : 			'./libr/froala/js/plugins/inline_style',
		'froala_line_breaker' : 			'./libr/froala/js/plugins/line_breaker',
		'froala_link' : 					'./libr/froala/js/plugins/link',
		'froala_lists' : 					'./libr/froala/js/plugins/lists',
		'froala_paragraph_format' : 		'./libr/froala/js/plugins/paragraph_format',
		'froala_paragraph_style' : 			'./libr/froala/js/plugins/paragraph_style',
		'froala_quick_insert' : 			'./libr/froala/js/plugins/quick_insert',
		'froala_quote' : 					'./libr/froala/js/plugins/quote',
		'froala_save' : 					'./libr/froala/js/plugins/save',
		'froala_table' : 					'./libr/froala/js/plugins/table',
		'froala_url' : 						'./libr/froala/js/plugins/url',
		'froala_video' : 					'./libr/froala/js/plugins/video',
		'countup' : 						'./libr/countup/countUp',

		// 'froala_editor': 					'./libr/jquery-froala-editor/js/froala_editor.min',
		// 'froala_editor_langs_es': 			'./libr/jquery-froala-editor/js/langs/es',
		// // 'froala_editor_file_upload': 		'./libr/jquery-froala-editor/js/plugins/file_upload.min',
		// 'froala_editor_char_counter': 	    './libr/jquery-froala-editor/js/plugins/char_counter.min',
		// 'froala_editor_colors': 		    './libr/jquery-froala-editor/js/plugins/colors.min',
		// // 'froala_editor_link': 		        './libr/jquery-froala-editor/js/plugins/link.min',
		// 'froala_editor_media_manager': 		'./libr/jquery-froala-editor/js/plugins/media_manager.min',
		// 'froala_editor_lists': 		        './libr/jquery-froala-editor/js/plugins/lists.min',

		"jquery_validate": 					'./libr/jquery-validation/dist/jquery.validate',
		"jquery_validate_am": 				'./libr/jquery-validation/dist/additional-methods',
		"jquery_validate_es": 				'./libr/jquery-validation/dist/localization/messages_es',
		"formchange": 				        './libr/jquery-formchange/jquery.formchange',


		"mdl_component_handler": 			'./libr/material-design-lite/src/mdlComponentHandler',

		'mdl_button': 				        './libr/material-design-lite/src/button/button',
		'mdl_tabs': 				        './libr/material-design-lite/src/tabs/tabs',
		'mdl_textfield': 					'./libr/material-design-lite/src/textfield/textfield',
		'mdl_ripple': 						'./libr/material-design-lite/src/ripple/ripple',

		"jquery-dimensions": 				'./libr/jquery-dimensions-popup/dimensions',

        "bootstrap-toolkit": 				'./libr/responsive-toolkit/src/bootstrap-toolkit',
        "lazysizes": 						'./libr/lazysizes/lazysizes-umd',
        "ls_bgset": 						'./libr/lazysizes/plugins/bgset/ls.bgset',
        "ls_respimg": 						'./libr/lazysizes/plugins/respimg/ls.respimg',
        // "ls_unveilhooks": 					'./libr/lazysizes/plugins/ls.unveilhooks',
        "ls_progressive": 					'./libr/lazysizes/plugins/progressive/ls.progressive',
        "ls_fios": 							'./libr/lazysizes/plugins/fix-ios-sizes/fix-ios-sizes',
        "TweenLite": 						'./libr/gsap/src/uncompressed/TweenLite',
        "TweenMax": 						'./libr/gsap/src/uncompressed/TweenMax',
        "TimelineMax": 						'./libr/gsap/src/uncompressed/TimelineMax',

        "jquery_mmenu_all_min_js": 			'./libr/jquery.mmenu/dist/js/jquery.mmenu.all.min.umd',
        "malihu_custom_scrollbar_plugin": 	'./libr/malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar',
        "jquery-mousewheel": 				'./libr/jquery-mousewheel/jquery.mousewheel',
        "ScrollMagic": 						'./libr/scrollmagic/scrollmagic/uncompressed/ScrollMagic',
        "jquery.ScrollMagic": 				'./libr/scrollmagic/scrollmagic/uncompressed/plugins/jquery.ScrollMagic',
        "debug.addIndicators": 				'./libr/scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators',
        "animation.gsap": 					'./libr/scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap',
        "animation.velocity": 				'./libr/scrollmagic/scrollmagic/uncompressed/plugins/animation.velocity',

		"Waypoints": 						'./libr/waypoints/lib/jquery.waypoints',
		"WaypointsSticky": 					'./libr/waypoints/lib/shortcuts/sticky',
		"WaypointsInview": 					'./libr/waypoints/lib/shortcuts/inview',


		"EventEmitter": 					'./libr/node-eventemitter/EventEmitter',
		"bootbox": 							'./libr/requirejs-3rdlib/bootbox/bootbox',
		"Twitter": 							'./libr/requirejs-3rdlib/twitter/Twitter',
		"Facebook": 						'./libr/requirejs-3rdlib/facebook/facebook',
		// "YouTubePlayer": 					'./libr/requirejs-3rdlib/google/YouTubePlayer',
		"YouTubePlayer": 					'https://www.youtube.com/iframe_api?noext',
		"GoogleAnalytics": 					'./libr/requirejs-3rdlib/google/GoogleAnalytics',
		"GoogleMap": 						'./libr/requirejs-3rdlib/google/GoogleMap',
		"disqus": 							'./libr/requirejs-3rdlib/disqus/disqus',

		"leaflet": 							'./libr/leaflet/dist/leaflet-src',
		"leaflet_mark": 					'./libr/leaflet.bouncemarker/bouncemarker',

		"fancybox": 						'./libr/jquery-fancybox/source/js/jquery.fancybox',


		"owl_slider": 						'./libr/owl.carousel/src/js/owl.carousel',
		"owl_slider_animate": 				'./libr/owl.carousel/src/js/owl.animate',
		"owl_slider_autorefresh": 			'./libr/owl.carousel/src/js/owl.autorefresh',

		"owl_slider_autoplay": 				'./libr/owl.carousel/src/js/owl.autoplay',
		"owl_slider_hash": 					'./libr/owl.carousel/src/js/owl.hash',
		"owl_slider_navigation": 			'./libr/owl.carousel/src/js/owl.navigation',

		"owl_slider_support": 				'./libr/owl.carousel/src/js/owl.support',

		"bootstrap_transition": 			'./libr/bootstrap-sass/assets/javascripts/bootstrap/transition',
		"bootstrap_affix": 					'./libr/bootstrap-sass/assets/javascripts/bootstrap/affix',
		"bootstrap_alert": 					'./libr/bootstrap-sass/assets/javascripts/bootstrap/alert',
		"bootstrap_button": 				'./libr/bootstrap-sass/assets/javascripts/bootstrap/button',
		"bootstrap_carousel": 				'./libr/bootstrap-sass/assets/javascripts/bootstrap/carousel',
		"bootstrap_collapse": 				'./libr/bootstrap-sass/assets/javascripts/bootstrap/collapse',
		"bootstrap_dropdown": 				'./libr/bootstrap-sass/assets/javascripts/bootstrap/dropdown',
		"bootstrap_modal": 					'./libr/bootstrap-sass/assets/javascripts/bootstrap/modal',
		"bootstrap_scrollspy": 				'./libr/bootstrap-sass/assets/javascripts/bootstrap/scrollspy',

		"bootstrap_tab": 					'./libr/bootstrap-sass/assets/javascripts/bootstrap/tab',
		"bootstrap_tooltip": 				'./libr/bootstrap-sass/assets/javascripts/bootstrap/tooltip',
		"bootstrap_popover": 				'./libr/bootstrap-sass/assets/javascripts/bootstrap/popover',

		"backbone": 						'./libr/backbone/backbone',

		"mustache": 						'./libr/mustache/mustache',
		"select2": 							'./libr/select2/dist/js/select2.full',
		"select2_i18n_es": 					'./libr/select2/dist/js/i18n/es',

		"bridget": 			        		'./libr/jquery-bridget/jquery.bridget',

		"cols": 				       		'./site/cols',
		"even": 							'./site/even',
		"boot": 							'./site/boot',
		// "site": 							'./site/site',
		"tmpl": 							'./site/tmpl',

		"jquery-scrollto": 					'./libr/jquery-flesler-scrollto/jquery.scrollTo',

		"bootstrap_datetimepicker": 		'./libr/eonasdan-bootstrap-datetimepicker/src/js/bootstrap-datetimepicker',

		"moment": 							'./libr/moment/min/moment-with-locales.min',
		// "d3": 							'./libr/d3/d3',
		// "d3": 							'./libr/d3/src/d3',
		'stripe': 							'https://js.stripe.com/v2/?1',
		'stripe_checkout': 					'https://checkout.stripe.com/checkout',
        "paypal_checkout": 					'https://www.paypalobjects.com/api/checkout',
		'dotdotdot':  						'./libr/jquery-dotdotdot/src/jquery.dotdotdot.min.umd',

		'd3v3':  							'./libr/d3_v3/d3.min',
		'd3':  								'./libr/d3_v4/d3.min',

		'd3_transition': 					'./libr/d3-transition/build/d3-transition',
		'd3_hierarchy': 					'./libr/d3-hierarchy/build/d3-hierarchy',
		'd3_selection': 					'./libr/d3-selection/build/d3-selection',
		'd3_format': 						'./libr/d3-format/build/d3-format',
		'd3_scale': 						'./libr/d3-scale/build/d3-scale',
		'd3_color': 						'./libr/d3-color/build/d3-color',
		'd3_zoom': 							'./libr/d3-zoom/build/d3-zoom',
		'd3_path': 							'./libr/d3-path/build/d3-path',

		'd3_interpolate': 					'./libr/d3-interpolate/build/d3-interpolate',
		'd3_time_format': 					'./libr/d3-time-format/build/d3-time-format',
		'd3_collection': 					'./libr/d3-collection/build/d3-collection',
		'd3_dispatch': 						'./libr/d3-dispatch/build/d3-dispatch',
		'd3_array': 						'./libr/d3-array/build/d3-array',
		'd3_timer': 						'./libr/d3-timer/build/d3-timer',
		'd3_ease': 							'./libr/d3-ease/build/d3-ease',
		'd3_time': 							'./libr/d3-time/build/d3-time',
		'd3_drag': 							'./libr/d3-drag/build/d3-drag',

		"c3": 								'./libr/c3/c3',

		"jquery_dfp": 						'./libr/jquery.dfp/jquery.dfp',
		"papaparse": 						'./libr/papaparse/papaparse',

		"part": 							'./site/part',
		"body": 							'./site/view/body',
		"main_head": 						'./site/view/part/main_head',
		"main_navi": 						'./site/view/part/main_navi',
		"main_link": 						'./site/view/part/main_link',
		"main_cell": 						'./site/view/part/main_cell',
		"main_line":						'./site/view/part/main_line',
		"main_nets":						'./site/view/part/main_nets',
		"main_info":						'./site/view/part/main_info',
		"main_foot":						'./site/view/part/main_foot',
		"main_page":						'./site/view/part/main_page',

		"card": 							'./site/card',
		"busy": 							'./site/busy',
		"user": 							'./site/user',
		"bulk": 							'./site/bulk',
		"post": 							'./site/post',
		"post_activity": 					'./site/post_activity',
		"note": 							'./site/note',
		"pag_dashboard": 					'./site/page/pag_dashboard',
		"pag_base": 						'./site/page/pag_base',
		"pag_home": 						'./site/page/pag_home',
		"pag_find": 						'./site/page/pag_find',
		"pag_section": 						'./site/page/pag_shot',
		"pag_shot_cols": 					'./site/page/pag_shot_cols',
		"is_probe": 						'./libr/iscroll/build/iscroll-probe',
		"pag_main_goup": 					'./site/page/pag_main_goup',
		"pag_post_toon": 					'./site/page/pag_post_toon',
		"pag_post_pict_only": 				'./site/page/pag_post_pict_only',
		"pag_post_pict_many": 				'./site/page/pag_post_pict_many',
		// "pag_post_pict_full": 				'./site/page/pag_post_pict_full',
		"pag_post_pict_trip": 				'./site/page/pag_post_pict_trip',
		"pag_post_pict_full": 				'./site/page/pag_post_pict_full_next',
		"pag_post_pict_full_mozote": 		'./site/page/pag_post_pict_full_next',
		"pag_post_pict_full_mozote": 		'./site/page/pag_post_pict_full_next',
		"pag_post_pict_full_stop": 			'./site/page/pag_post_pict_full_stop',
		"pag_post_pict_wide": 				'./site/page/pag_post_pict_wide',
		"pag_post_view_full": 				'./site/page/pag_post_view_full',
		"pag_post_sing_full": 				'./site/page/pag_post_sing_full',

		"pag_shot_poli": 					'./site/page/pag_shot_poli',
		"pag_page_poli": 					'./site/page/pag_page_poli',
		"pag_page_poli_quepasacon": 		'./site/page/pag_page_poli_quepasacon',
		"pag_page_poli_efelectoral": 		'./site/page/pag_page_poli_efelectoral',

		"pag_main_only": 					'./site/page/pag_main_only',
		"pag_main_tell": 					'./site/page/pag_main_tell',
		"pag_main_dany_only": 				'./site/page/pag_main_dany_only',
		"pag_main_graf_only": 				'./site/page/pag_main_graf_only',
		"pag_single": 						'./site/page/pag_single',
		"pag_post_pref": 					'./site/page/pag_post_pref',
		"pag_especial_violaciones": 		'./site/page/pag_especial_violaciones',
		"pag_excavacion_ciudadana": 		'./site/page/pag_excavacion_ciudadana',
		"pag_foro_paid": 					'./site/page/pag_foro_paid',
		"pag_foro_2017": 					'./site/page/pag_foro_2017',
		"pag_foro_actividades": 			'./site/page/pag_foro_actividades',
		"pag_foro_2017_invitados": 			'./site/page/pag_foro_2017_invitados',
		"pag_case": 						'./site/page/pag_case',
		"user_auth": 						'./site/page/user_auth',
		"user_join": 						'./site/page/user_join'
	}
	,
	'hbs':
	{
		'i18n': false,
		'helpers': true,
		'templateExtension': 'hbs',
		'helperDirectory' : "../../hbs/helpers/",
		'partialsUrl': '../../../resources/views/hbs/',
		'handlebarsPath': "handlebars"
	}
	,
	map: {
		'*':
		{
			// 'd3/selection':  'd3src/d3-selection.v1.min',
			// 'd3/path': 'd3src/d3-path.v1.min',
			// 'd3/format': 'd3src/d3-format.v1.js'
			// 'd3':  				'./libr/d3/build/d3',
			// 'd3/selection': 	'./libr/d3-selection/build/d3-selection',
			// 'd3/path': 			'./libr/d3-path/build/d3-path',
			// 'd3/format': 		'd3_format'

			'jquery-bridget': 	'bridget',

			'd3/transition': 	'd3_transition',
			'd3-transition': 	'd3_transition',
			'd3/hierarchy': 	'd3_hierarchy',
			'd3-hierarchy': 	'd3_hierarchy',
			'd3/selection': 	'd3_selection',
			'd3-selection': 	'd3_selection',
			'd3/format': 		'd3_format',
			'd3-format': 		'd3_format',
			'd3/scale': 		'd3_scale',
			'd3-scale': 		'd3_scale',
			'd3/color': 		'd3_color',
			'd3-color': 		'd3_color',
			'd3/zoom': 			'd3_zoom',
			'd3-zoom': 			'd3_zoom',


			'd3/interpolate': 	'd3_interpolate',
			'd3-interpolate': 	'd3_interpolate',
			'd3/time-format': 	'd3_time_format',
			'd3-time-format': 	'd3_time_format',
			'd3/collection': 	'd3_collection',
			'd3-collection': 	'd3_collection',
			'd3/dispatch': 		'd3_dispatch',
			'd3-dispatch': 		'd3_dispatch',
			'd3/array': 		'd3_array',
			'd3-array': 		'd3_array',
			'd3/timer': 		'd3_timer',
			'd3-timer': 		'd3_timer',
			'd3/ease': 			'd3_ease',
			'd3-ease': 			'd3_ease',
			'd3/time': 			'd3_time',
			'd3-time': 			'd3_time',
			'd3/drag': 			'd3_drag',
			'd3-drag': 			'd3_drag'
		}
		,
		'dotdotdot':
		{
			'jQuery': 'jquery'
		}
		,
		'malihu_custom_scrollbar_plugin':
		{
			'jQuery': 'jquery'
		}
		,
		'Facebook':
		{
			'eventemitter': 'EventEmitter'
		}
		,
		'jquery_validate_es':
		{
			'../jquery.validate': 'jquery_validate'
		}
		,
		'jquery_validate_am':
		{
			'jquery.validate': 'jquery_validate'
		}
	}
	,
	'shim' : {
		// 'boot' : 							{ deps : ['domready'] },
		'jquery' : 							{ deps : ['domready'], exports : 'jQuery' },
		'jquery_validate_es' : 				{ deps : ['jquery_validate'] },
		'jquery_validate_am' : 				{ deps : ['jquery_validate_es'] },
		// 'jquery' : 							{ exports : '$' },
		'yui_yql' : 					    { deps : ['yui_yui'] },
		'jquery-scrollto' : 			    { deps : ['jquery'] },
		'formchange' : 			  	        { deps : ['jquery'] },
		// 'mdl_component_handler' : 			{ exports : 'componentHandler' },

		'mdl_button' : 						{ deps : ['mdl_component_handler'] },
		'mdl_tabs' : 						{ deps : ['mdl_component_handler'] },
		'mdl_textfield' : 					{ deps : ['mdl_component_handler'] },
		'mdl_ripple' : 						{ deps : ['mdl_component_handler', 'mdl_button', 'mdl_tabs'] },

		'owl_slider' : 						{ deps : ['jquery'] },
		'owl_slider_autorefresh': 			{ deps : ['owl_slider'] },
		'owl_slider_lazyload': 				{ deps : ['owl_slider'] },
		'owl_slider_autoheight': 			{ deps : ['owl_slider'] },
		'owl_slider_video': 				{ deps : ['owl_slider'] },
		'owl_slider_autoplay': 				{ deps : ['owl_slider'] },
		'owl_slider_navigation': 			{ deps : ['owl_slider'] },
		'owl_slider_hash': 					{ deps : ['owl_slider'] },
		'owl_slider_animate': 				{ deps : ['owl_slider'] },
		'owl_slider_support': 				{ deps : ['owl_slider'] },

		'underscore' : 						{ exports : '_' },
		// 'handlebars':             			{ exports: 'Handlebars' },
		// 'handlebars.runtime':     			{ exports: 'Handlebars' },
		// 'tmpl' : 			        		{ deps : ['handlebars.runtime'] },
		'backbone' : 						{ deps : ['jquery', 'underscore'], exports : 'Backbone'},
		'YouTubePlayer' : 					{ deps : ['jquery'], exports: 'YT' },
		'Twitter' : 						{ deps : ['jquery'] },
		'cookies' : 						{ deps : ['jquery'], exports: 'Cookies'},
		'jquery-dimensions' : 		    	{ deps : ['jquery']},
		'bootstrap-toolkit' : 		    	{ deps : ['jquery']},
		'Waypoints' : 		    			{ deps : ['jquery']},
		'WaypointsSticky' : 				{ deps : ['Waypoints']},
		'WaypointsInview' : 				{ deps : ['Waypoints']},
		// 'disqus' : 		    				{ deps : ['jquery']},
		// 'bootbox' : 			    		{ deps : ['jquery'], exports: 'bootbox'},
		// 'FileAPI_exif' : 				    { deps : ['FileAPI']},
		// 'FileAPI_jquery' : 				    { deps : ['FileAPI'], exports: '$.fn.fileapi'},
		// 'inview' : 		    				{ deps : ['jquery']},



		'froala_editor' : 					{ deps : ['jquery', 'jquery_validate_am'] },
		'froala_languages_es' : 			{ deps : ['froala_editor'] },
		'froala_align' : 					{ deps : ['froala_editor'] },
		'froala_char_counter' : 			{ deps : ['froala_editor'] },
		'froala_code_beautifier' : 			{ deps : ['froala_editor'] },
		'froala_code_view' : 				{ deps : ['froala_editor'] },
		'froala_colors' : 					{ deps : ['froala_editor'] },
		'froala_draggable' : 				{ deps : ['froala_editor'] },
		'froala_emoticons' : 				{ deps : ['froala_editor'] },
		'froala_entities' : 				{ deps : ['froala_editor'] },
		'froala_file' : 					{ deps : ['froala_editor'] },
		'froala_font_family' : 				{ deps : ['froala_editor'] },
		'froala_font_size' : 				{ deps : ['froala_editor'] },
		'froala_forms' : 					{ deps : ['froala_editor'] },
		'froala_fullscreen' : 				{ deps : ['froala_editor'] },
		'froala_image_manager' : 			{ deps : ['froala_editor', 'froala_image'] },
		'froala_image' : 					{ deps : ['froala_editor'] },
		'froala_inline_style' : 			{ deps : ['froala_editor'] },
		'froala_line_breaker' : 			{ deps : ['froala_editor'] },
		'froala_link' : 					{ deps : ['froala_editor'] },
		'froala_lists' : 					{ deps : ['froala_editor'] },
		'froala_paragraph_format' : 		{ deps : ['froala_editor'] },
		'froala_paragraph_style' : 			{ deps : ['froala_editor'] },
		'froala_quick_insert' : 			{ deps : ['froala_editor'] },
		'froala_quote' : 					{ deps : ['froala_editor'] },
		'froala_save' : 					{ deps : ['froala_editor'] },
		'froala_table' : 					{ deps : ['froala_editor'] },
		'froala_url' : 						{ deps : ['froala_editor'] },
		'froala_video' : 					{ deps : ['froala_editor'] },


		// 'froala_editor' : 					{ deps : ['jquery'] },
		// 'froala_editor_langs_es' : 			{ deps : ['froala_editor'] },
		// 'froala_editor_lists' : 	        { deps : ['froala_editor'] },
		// // 'froala_editor_file_upload' : 		{ deps : ['froala_editor'] },
		// // 'froala_editor_media_manager' : 	{ deps : ['froala_editor_file_upload'] },
		// 'froala_editor_colors' : 			{ deps : ['froala_editor'] },
		// // 'froala_editor_link' : 				{ deps : ['froala_editor'] },
		// 'froala_editor_char_counter' : 		{ deps : ['froala_editor'] },

		'jcrop' : 				    		{ deps : ['jquery'], exports: '$.Jcrop'},
		'backbone_filters' : 				{ deps : ['backbone'] },
		'mustache' : 						{ exports : 'Mustache' },
		'bootstrap_affix': 					{ deps: ['jquery'], exports: '$.support.affix' },
		'bootstrap_alert': 					{ deps: ['jquery'], exports: '$.fn.alert' },
		'bootstrap_button': 				{ deps: ['jquery'], exports: '$.fn.button' },
		'bootstrap_carousel': 				{ deps: ['jquery'], exports: '$.fn.carousel' },
		'bootstrap_collapse': 				{ deps: ['jquery'], exports: '$.fn.collapse' },
		'bootstrap_dropdown': 				{ deps: ['jquery'], exports: '$.fn.dropdown' },
		'bootstrap_modal': 					{ deps: ['jquery'], exports: '$.fn.modal' },
		'bootstrap_scrollspy': 				{ deps: ['jquery'], exports: '$.fn.scrollspy' },
		'bootstrap_tab': 					{ deps: ['jquery'], exports: '$.fn.tab' },
		'bootstrap_tooltip': 				{ deps: ['jquery'], exports: '$.support.tooltip' },
		'bootstrap_transition': 			{ deps: ['jquery'], exports: '$.support.transition' },
		'bootstrap_popover': 				{ deps: ['jquery', 'bootstrap_tooltip'], exports: '$.fn.popover' },
		'bootstrap_datetimepicker': 		{ deps: ['jquery'/*, 'moment'*/] },

		'mag-analytics' : 					{ deps: [] },
		'mag' : 							{ deps: ['jquery', 'mag-analytics' ] },
		'mag-control' : 					{ deps: ['jquery', 'mag', 'jquery-bridget', 'mag-analytics'] },
		'mag-jquery' : 						{ deps: ['jquery', 'jquery-bridget', 'hammerjs', 'prevent-ghost-click', 'jquery-mousewheel'] },

		// 'bootstrap_checkbox_x': 			{ deps: ['jquery'], exports: '$.fn.checkboxX' },
		// 'select2_sortable': 				{ deps: ['select2', 'sortable'] },
		'select2': 							{ deps: ['jquery'], exports: '$.fn.select2' },
		'select2_i18n_es': 					{ deps: ['select2'] },
		// 'responsejs': 						{ deps: ['jquery'] },

		'd3_transition': 					{ deps: ['jquery'], exports: ['d3_transition']},
		'd3_hierarchy': 					{ deps: ['jquery'], exports: ['d3_hierarchy']},
		'd3_selection': 					{ deps: ['jquery'], exports: ['d3_selection']},
		'd3_format': 						{ deps: ['jquery'], exports: ['d3_format']},
		'd3_scale': 						{ deps: ['jquery'], exports: ['d3_scale']},
		'd3_color': 						{ deps: ['jquery'], exports: ['d3_color']},
		'd3_zoom': 							{ deps: ['jquery'], exports: ['d3_zoom']},

		'd3_interpolate': 					{ deps: ['jquery'], exports: ['d3_interpolate']},
		'd3_time_format': 					{ deps: ['jquery'], exports: ['d3_time_format']},
		'd3_collection': 					{ deps: ['jquery'], exports: ['d3_collection']},
		'd3_dispatch': 						{ deps: ['jquery'], exports: ['d3_dispatch']},
		'd3_array': 						{ deps: ['jquery'], exports: ['d3_array']},
		'd3_timer': 						{ deps: ['jquery'], exports: ['d3_timer']},
		'd3_ease': 							{ deps: ['jquery'], exports: ['d3_ease']},
		'd3_time': 							{ deps: ['jquery'], exports: ['d3_time']},
		'd3_drag': 							{ deps: ['jquery'], exports: ['d3_drag']},

		'd3': 						        { deps: ['jquery'] },
		'c3': 						        { deps: ['d3v3'] },
		// 'd3.geo.projection': 				{ deps: ['d3']},
		// 'd3.layout.cloud': 					{ deps: ['d3']},
		// 'timeline': 						{ deps: ['moment'] },
		'malihu_custom_scrollbar_plugin': 	{ deps: ['jquery'] },
		'bridget': 							{ deps: ['jquery'] },
		'isotope': 							{ deps: ['jquery'], exports: '$.fn.isotope'  },
		'fancybox': 						{ deps: ['jquery'] },
        'leaflet': 							{ exports: 'L' },
        'leaflet_mark': 					{ deps: ['leaflet'] },
		'stripe': 							{ exports: 'Stripe' }
	}

});
// };
define("site", function(){});

